'use client';

import { sendGTMEvent } from '@next/third-parties/google';

import { GTMEvent } from '@/constants/firebase';
import { SearchParams } from '@/constants/listing-search-keys';

export type SearchSubmitEventData = {
  arrive?: string;
  depart?: string;
  flex_days?: string;
  flex_weeks?: string;
  adults?: string;
  children?: string;
  resort_id?: string;
};

export const parseSearchSubmitEventData = (
  params: URLSearchParams
): SearchSubmitEventData => {
  const eventData: SearchSubmitEventData = {};

  const arrive = params.get(SearchParams.ARRIVE);
  const depart = params.get(SearchParams.DEPART);
  const flexDays = params.get(SearchParams.FLEX_DAYS);
  const flexWeeks = params.get(SearchParams.FLEX_WEEKS);
  const adults = params.get(SearchParams.ADULTS);
  const children = params.get(SearchParams.CHILDREN);
  const resortId = params.get(SearchParams.RESORT);

  if (arrive) eventData.arrive = arrive;
  if (depart) eventData.depart = depart;
  if (flexDays) eventData.flex_days = flexDays;
  if (flexWeeks) eventData.flex_weeks = flexWeeks;
  if (adults) eventData.adults = adults;
  if (children) eventData.children = children;
  if (resortId) eventData.resort_id = resortId;

  return eventData;
};

export const logSearchSubmit = (params: URLSearchParams) => {
  sendGTMEvent({
    event: GTMEvent.SearchSubmit,
    eventData: parseSearchSubmitEventData(params),
  });
};
